import {PropsWithChildren} from 'react';
import {THEME_VARIANTS} from '@apps-common/ui-theme/Constants';
import {ThemeProvider} from '@mui/material';
import {createPlanetTheme} from '@apps-common/ui-theme/Themes';

export const PlanetThemeProvider: React.FC<PropsWithChildren> = ({children}) => {
  return (
    <ThemeProvider
      theme={createPlanetTheme()}
      defaultMode={THEME_VARIANTS.DARK}
      modeStorageKey="phoenix-theme-mode"
      // @ts-expect-error does not expect this prop even though it exists.
      forceThemeRerender
    >
      {children}
    </ThemeProvider>
  );
};
